import { render, staticRenderFns } from "./FollowupsFilterCards.vue?vue&type=template&id=44e6185b&scoped=true"
import script from "./FollowupsFilterCards.vue?vue&type=script&lang=js"
export * from "./FollowupsFilterCards.vue?vue&type=script&lang=js"
import style0 from "./FollowupsFilterCards.vue?vue&type=style&index=0&id=44e6185b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e6185b",
  null
  
)

export default component.exports